import { call, put } from 'redux-saga/effects';

import { setAccessRefreshTokens } from 'api/utils/tokenManagement';
import { IRotatedAuthTokensResponse } from 'api/components/Auth/types';
import api from 'api';

import { getUserFeatures } from 'store/user/actions';
import { notifyError } from 'store/notifications/actions';

import { authenticateByCWTToken, setAuthenticationStatus, setAuthRedirectUrl } from '../actions';

import { Provider } from 'services/Analytics/core';

import { getParamFromUrl } from 'helpers/utils';
import { getWFTokenForWebPlatform, waitForGetCurrentUser } from './helpers';

export function* authenticateByCWTTokenSaga({ payload }: ReturnType<typeof authenticateByCWTToken>) {
    const { onSuccess, onError, authToken } = payload;
    const utmSource = getParamFromUrl('utm_source') || 'default_device';

    localStorage.setItem('utmSource', utmSource);
    Provider.setUTMSource(utmSource);

    try {
        const { access, refresh }: IRotatedAuthTokensResponse = yield call(api.auth.getTokenByCWT, {
            token: authToken,
        });

        yield call(setAccessRefreshTokens, { access, refresh });

        yield call(waitForGetCurrentUser);

        yield call(getWFTokenForWebPlatform);

        yield put(setAuthenticationStatus(true));

        if (onSuccess) {
            yield call(onSuccess);
        }

        yield put(getUserFeatures());
        yield put(setAuthRedirectUrl(null));
    } catch (error: any) {
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
        yield put(setAuthenticationStatus(false));

        if (onError) {
            yield call(onError, error);
        }
    }
}
